import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'zoomable-image',
  templateUrl: './zoomable-image.component.html',
  styleUrls: ['./zoomable-image.component.scss'],
})
export class ZoomableImageComponent implements OnInit {

  @Input() public image;
  @ViewChild('pinch', {static: false}) pinch;
  @Output() zoomChanged = new EventEmitter<number>();

  lastZoomLevel = 1;

  constructor() { }

  ngOnInit() {
  }

  handleEvent(zoomLevel) {
    if (zoomLevel !== this.lastZoomLevel){
      this.zoomChanged.emit(zoomLevel);
      this.lastZoomLevel = zoomLevel;
    }
  }

}
